import { ReactElement } from 'react';
import gruppeMaskieren1 from '@app/assets/images/home/gruppe-maskieren-1.png';

const Footer = (): ReactElement => {
  return (
    <footer id="bottom" className="rf22">
      <div className="grid-container full prefooter hide-for-small-only">
        <div className="grid-x align-middle grid-padding-x">
          <div className="small-2 medium-4 large-4 cell hide-for-small-only">
            <figure className="prefooter-figure">
              <img alt="RHI Magnesita transparent logo" src={gruppeMaskieren1} />
            </figure>
          </div>
          <div className="small-10 medium-8 large-6 cell">
            <div className="prefooter-claim h1 content-dark">Taking innovation to 1200&nbsp;°C and beyond</div>
          </div>
        </div>
      </div>
      <div className="grid-container mainfooter content-dark">
        <div className="grid-x grid-padding-x align-top">
          <div className="medium-2 small-6 cell footer-menu-logo">
            <a
              title="Link to RHI Magnesita website"
              className="logo-link block"
              href="https://www.rhimagnesita.com"
              target="_blank"
              rel="noreferrer noopener"
            >
              <svg
                id="rhi_magnesita_logo"
                data-name="rhi_magnesita_logo"
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                width="91.063"
                height="54"
                viewBox="0 0 91.063 54"
              >
                <g id="Gruppe_5" data-name="Gruppe 5">
                  <path
                    id="logocolor"
                    data-name="Pfad 11"
                    d="M46.829,52.4a2.706,2.706,0,0,1-1.058.216c-1.838,0-3.1-.9-3.1-2.943a2.724,2.724,0,0,1,2.846-2.966,3.009,3.009,0,0,1,2.2.805,1.357,1.357,0,0,0,.576-.974.8.8,0,0,0-.42-.636,4.124,4.124,0,0,0-2.33-.576,4.192,4.192,0,0,0-4.467,4.347c0,2.859,1.934,4.324,4.671,4.324a4.415,4.415,0,0,0,2.546-.685V49.952a.746.746,0,0,0-.852-.816H44.956a1.923,1.923,0,0,0-.084.563c0,.552.227.769.709.769h1.249ZM24.394,53.784c.06-1.105.253-4.864.325-5.969.576,1.116,1.561,3.17,1.874,3.915a1.713,1.713,0,0,0,.613.12,1.774,1.774,0,0,0,.613-.12c.347-.782,1.5-3.182,1.872-3.938.036.72.313,5.236.349,5.992h1.488c-.071-1.358-.37-6.7-.456-8.072a2.235,2.235,0,0,0-.889-.167,1.158,1.158,0,0,0-1.165.709c-.323.659-1.321,2.75-1.778,3.722l-2.065-4.264a2.207,2.207,0,0,0-.829-.167.973.973,0,0,0-1.045.985c-.084,1.056-.349,5.992-.409,7.254ZM0,53.784H1.491V50.757a10.4,10.4,0,0,0,1.225.084A6.642,6.642,0,0,0,3.4,50.8a27.929,27.929,0,0,1,1.7,2.979H6.823A27.524,27.524,0,0,0,4.89,50.458a2.378,2.378,0,0,0,1.538-2.33c0-1.634-1.225-2.666-3.664-2.666a12.109,12.109,0,0,0-2.1.12A.73.73,0,0,0,0,46.361Zm1.491-6.941a7.207,7.207,0,0,1,1.236-.073c1.694,0,2.139.649,2.139,1.369,0,.842-.516,1.394-2.1,1.394a5.445,5.445,0,0,1-1.272-.1Zm32.463,6.941c.18-.492.456-1.225.805-2.1h3.615c.253.636.66,1.7.805,2.1h1.657c-.385-1.022-2.619-6.847-3.388-8.143a2.234,2.234,0,0,0-.792-.146,1.172,1.172,0,0,0-1.189.855c-1.129,2.533-2.257,5.32-3.026,7.433Zm1.285-3.412c.433-1.176,1-2.461,1.358-3.279.227.492.936,2.174,1.321,3.279Zm30.555,2.679A6.517,6.517,0,0,0,69.24,54c2.174,0,3.352-1.009,3.352-2.533,0-1.382-.912-2.127-2.546-2.427l-1.225-.229c-.912-.167-1.358-.48-1.358-1.092,0-.649.433-1.058,1.657-1.058a3.681,3.681,0,0,1,2.572.878,1.292,1.292,0,0,0,.48-.938.794.794,0,0,0-.433-.647,4.517,4.517,0,0,0-2.643-.625c-2.247,0-3.182,1.129-3.182,2.487,0,1.512,1.249,2.174,2.51,2.4l1.2.216c.792.146,1.345.386,1.345,1.131,0,.683-.529,1.079-1.7,1.079a5.148,5.148,0,0,1-2.8-.805ZM9.513,45.628a2.289,2.289,0,0,0-.673-.083c-.492,0-.852.216-.852.659v7.579H9.513v-3.6h3.842v3.6h1.527V45.628a2.289,2.289,0,0,0-.672-.083c-.493,0-.855.216-.855.659v2.619H9.513Zm47.44,0a2.266,2.266,0,0,0-.672-.083c-.54,0-.853.216-.853.659v5.129c-1-1.6-3.362-5.056-3.842-5.656a2.222,2.222,0,0,0-.733-.133c-.542,0-.962.216-.962.839v7.4h1.525V47.742c1.214,1.694,3.208,4.757,4,6.042h1.536Zm3.3,3.243V46.926h4.335a1.482,1.482,0,0,0,.084-.589c0-.443-.216-.792-.659-.792H59.609c-.576,0-.878.287-.878.816v7.423h5.945V52.4H60.258v-2.15h3.555a1.479,1.479,0,0,0,.084-.589c0-.443-.216-.792-.662-.792ZM73.8,53.784h1.527V45.628a2.29,2.29,0,0,0-.673-.083c-.516,0-.854.216-.854.66Zm9.417-6.858c.446,0,.662-.349.662-.792a1.456,1.456,0,0,0-.086-.589H76.963c-.443,0-.66.349-.66.792a1.507,1.507,0,0,0,.084.589h2.943v6.858h1.525V46.926ZM16.611,53.784h1.525V45.628a2.266,2.266,0,0,0-.672-.083c-.516,0-.852.216-.852.66Zm67.571,0c.18-.492.456-1.225.805-2.1H88.6c.251.636.66,1.7.8,2.1h1.658c-.383-1.021-2.617-6.847-3.386-8.143a2.244,2.244,0,0,0-.792-.146,1.176,1.176,0,0,0-1.191.855c-1.129,2.534-2.258,5.32-3.026,7.434Zm1.285-3.411c.433-1.176,1-2.461,1.358-3.279.227.492.936,2.174,1.319,3.279ZM61.35.3a1.577,1.577,0,0,0-.876-.3A1.593,1.593,0,0,0,59.6.3L44.752,8.865,29.955.3a1.61,1.61,0,0,0-.878-.3A1.562,1.562,0,0,0,28.2.3L12.949,9.128a1.172,1.172,0,0,0-.733,1.082,1.211,1.211,0,0,0,.733,1.058L28.2,20.1a1.565,1.565,0,0,0,.876.3,1.6,1.6,0,0,0,.878-.3L60.018,2.752a.928.928,0,0,1,.456-.169.987.987,0,0,1,.48.169L75.017,10.9a1.607,1.607,0,0,1,.769.889c1.116-.36,1.548-.865,1.548-1.55,0-.443-.216-.8-.985-1.249ZM42.433,10.2,39.5,11.891,29.955,6.355a1.6,1.6,0,0,0-.878-.3,1.571,1.571,0,0,0-.876.3l-9.56,5.525L15.722,10.2l12.9-7.446a.933.933,0,0,1,.456-.169.922.922,0,0,1,.456.169Zm18.917,2.21a1.574,1.574,0,0,0-.876-.3,1.594,1.594,0,0,0-.878.3L29.534,29.75a.929.929,0,0,1-.456.169.987.987,0,0,1-.48-.169L14.533,21.607a1.6,1.6,0,0,1-.769-.889c-1.116.36-1.548.865-1.548,1.551,0,.443.216.8.985,1.248l15,8.682a1.573,1.573,0,0,0,.876.3,1.6,1.6,0,0,0,.878-.3L60.018,14.857a.92.92,0,0,1,.456-.167,1,1,0,0,1,.48.167L75.018,23a1.607,1.607,0,0,1,.769.889c1.116-.362,1.548-.865,1.548-1.55,0-.443-.216-.8-.985-1.249Zm0-6.054a1.566,1.566,0,0,0-.876-.3,1.6,1.6,0,0,0-.878.3L29.534,23.7a.926.926,0,0,1-.456.169.987.987,0,0,1-.48-.169L14.533,15.555a1.614,1.614,0,0,1-.769-.889c-1.116.36-1.548.865-1.548,1.548,0,.445.216.805.985,1.249l15,8.684a1.566,1.566,0,0,0,.876.3,1.6,1.6,0,0,0,.878-.3L60.018,8.8a.92.92,0,0,1,.456-.167,1,1,0,0,1,.48.167l14.064,8.143a1.624,1.624,0,0,1,.769.889c1.116-.36,1.548-.863,1.548-1.548,0-.445-.216-.805-.985-1.249Zm-32.729,7.8a.933.933,0,0,1,.456-.169.922.922,0,0,1,.456.169l3.052,1.741-3.052,1.754a.919.919,0,0,1-.456.167,1,1,0,0,1-.48-.167l-3.026-1.754ZM37.389,13.1l-2.906,1.681-4.528-2.619a1.656,1.656,0,0,0-.878-.3,1.573,1.573,0,0,0-.876.3L23.65,14.786l-2.9-1.681,7.866-4.54a.934.934,0,0,1,.456-.169.923.923,0,0,1,.456.169ZM28.2,38.254a1.565,1.565,0,0,0,.876.3,1.6,1.6,0,0,0,.878-.3L44.8,29.69l14.8,8.564a1.6,1.6,0,0,0,.878.3,1.572,1.572,0,0,0,.876-.3L76.6,29.427a1.169,1.169,0,0,0,.732-1.082,1.21,1.21,0,0,0-.732-1.056L61.35,18.461a1.565,1.565,0,0,0-.876-.3,1.6,1.6,0,0,0-.878.3L29.534,35.8a.919.919,0,0,1-.456.167,1,1,0,0,1-.48-.167L14.533,27.662a1.614,1.614,0,0,1-.769-.889c-1.116.36-1.548.863-1.548,1.548,0,.446.216.805.985,1.249Zm18.917-9.9,2.93-1.694L59.6,32.2a1.606,1.606,0,0,0,.878.3,1.564,1.564,0,0,0,.876-.3l9.56-5.523,2.919,1.681L60.93,35.8a.927.927,0,0,1-.456.167.937.937,0,0,1-.456-.167ZM60.93,24.407a.706.706,0,0,1-.912,0l-3.052-1.741,3.052-1.754a.928.928,0,0,1,.456-.169.988.988,0,0,1,.48.169l3.026,1.754Zm-8.768,1.045,2.906-1.681L59.6,26.388a1.639,1.639,0,0,0,.878.3,1.572,1.572,0,0,0,.876-.3L65.9,23.771l2.9,1.681-7.866,4.54a.927.927,0,0,1-.456.167.937.937,0,0,1-.456-.167Z"
                    transform="translate(0 0)"
                    fill="#3c4d5f"
                  ></path>
                </g>
              </svg>
            </a>
          </div>
          <div className="medium-3 small-12 cell footer-menu">
            <div className="menu-footer-main-menu-refresh-container">
              <ul id="menu-footer-main-menu-refresh" className="menu vertical">
                <li
                  id="menu-item-18086"
                  className="menu-item menu-item-type-custom menu-item-object-custom menu-item-18086"
                >
                  <a href="https://www.rhimagnesita.com/about/who-we-are/">About</a>
                </li>
                <li
                  id="menu-item-18102"
                  className="menu-item menu-item-type-post_type menu-item-object-page menu-item-18102"
                >
                  <a href="https://www.rhimagnesita.com/our-offering/">Solutions</a>
                </li>
                <li
                  id="menu-item-18143"
                  className="menu-item menu-item-type-custom menu-item-object-custom menu-item-18143"
                >
                  <a href="https://ir.rhimagnesita.com/corporate-governance/">Governance</a>
                </li>
                <li
                  id="menu-item-18144"
                  className="menu-item menu-item-type-custom menu-item-object-custom menu-item-18144"
                >
                  <a href="http://ir.rhimagnesita.com">Investors</a>
                </li>
                <li
                  id="menu-item-19935"
                  className="menu-item menu-item-type-post_type menu-item-object-page menu-item-19935"
                >
                  <a href="https://www.rhimagnesita.com/our-sustainability/">Sustainability</a>
                </li>
                <li
                  id="menu-item-18250"
                  className="menu-item menu-item-type-post_type menu-item-object-page menu-item-18250"
                >
                  <a href="https://www.rhimagnesita.com/media/news-archive/">Newsroom</a>
                </li>
                <li
                  id="menu-item-19938"
                  className="menu-item menu-item-type-post_type menu-item-object-page menu-item-19938"
                >
                  <a href="https://www.rhimagnesita.com/career/">Career</a>
                </li>
                <li
                  id="menu-item-18161"
                  className="menu-item menu-item-type-post_type menu-item-object-page menu-item-18161"
                >
                  <a href="https://www.rhimagnesita.com/contact/">Contact</a>
                </li>
              </ul>
            </div>
          </div>
          <div className="medium-3 small-12 cell left">
            <div className="menu-footer-menu-container">
              <ul id="menu-footer-menu" className="menu vertical">
                <li
                  id="menu-item-4249"
                  className="menu-item menu-item-type-custom menu-item-object-custom menu-item-4249"
                >
                  <a href="https://www.rhimagnesita.com/wp-content/uploads/2024/03/modern-slavery-statement-2024.pdf">
                    Anti Slavery
                  </a>
                </li>
                <li
                  id="menu-item-16353"
                  className="menu-item menu-item-type-post_type menu-item-object-page menu-item-16353"
                >
                  <a href="https://www.rhimagnesita.com/change-cookie-consent/">Change Cookie Consent</a>
                </li>
                <li
                  id="menu-item-16020"
                  className="menu-item menu-item-type-custom menu-item-object-custom menu-item-16020"
                >
                  <a href="https://ir.rhimagnesita.com/corporate-governance/code-of-cond">Code of Conduct</a>
                </li>
                <li
                  id="menu-item-22475"
                  className="menu-item menu-item-type-custom menu-item-object-custom menu-item-22475"
                >
                  <a href="https://ir.rhimagnesita.com/corporate-governance-2/compliance-helpline/">
                    Compliance Helpline
                  </a>
                </li>
                <li
                  id="menu-item-1547"
                  className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1547"
                >
                  <a href="https://www.rhimagnesita.com/data-protection-use-of-website/">
                    Data Protection &amp; Use of Website
                  </a>
                </li>
                <li
                  id="menu-item-1548"
                  className="menu-item menu-item-type-post_type menu-item-object-page menu-item-1548"
                >
                  <a href="https://www.rhimagnesita.com/imprint/">Imprint</a>
                </li>
                <li
                  id="menu-item-17938"
                  className="menu-item menu-item-type-post_type menu-item-object-page menu-item-17938"
                >
                  <a href="https://www.rhimagnesita.com/media-contacts/">Press</a>
                </li>
              </ul>
            </div>
          </div>
          <div className="large-1 show-for-large cell">&nbsp;</div>
          <div className="large-3 medium-4 small-12 cell footer-social-media">
            Follow us on social media
            <div className="social-media-nav grid-x align-center">
              <div className="cell auto center">
                <a
                  title="Link to RHI Magnesita page on Facebook"
                  href="https://www.facebook.com/rhimagnesita/"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  <span className="social-icon-new">
                    <svg
                      id="facebook-icon-svg"
                      xmlns="http://www.w3.org/2000/svg"
                      width="30.979"
                      height="30.786"
                      viewBox="0 0 30.979 30.786"
                    >
                      <path
                        id="facebook-icon-svg-path"
                        data-name="Pfad 1"
                        d="M30.979,15.49a15.543,15.543,0,0,1-13.069,15.3V19.967h3.611l.687-4.477h-4.3v-2.9a2.239,2.239,0,0,1,2.522-2.42h1.956V6.351a23.981,23.981,0,0,0-3.466-.3c-3.538,0-5.852,2.144-5.852,6.026V15.49H9.139v4.477h3.93V30.786a15.488,15.488,0,1,1,17.91-15.3Z"
                        transform="translate(0 0)"
                        fill="#0b2a4a"
                      ></path>
                    </svg>
                  </span>
                </a>
              </div>
              <div className="cell auto center">
                <a
                  title="Link to RHI Magnesita page on Instagram"
                  href="https://www.instagram.com/rhimagnesita/"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  <span className="social-icon-new">
                    <svg
                      id="instagram-icon-svg"
                      xmlns="http://www.w3.org/2000/svg"
                      width="30.979"
                      height="30.979"
                      viewBox="0 0 30.979 30.979"
                    >
                      <path
                        id="instagram-icon-svg-path"
                        data-name="Pfad 3"
                        d="M19.222,8.727H11.835A3,3,0,0,0,8.81,11.753v7.387a3,3,0,0,0,3.025,3.025h7.387a3,3,0,0,0,3.025-3.025V11.758A3,3,0,0,0,19.222,8.727ZM15.485,19.677a4.182,4.182,0,1,1,4.182-4.182A4.177,4.177,0,0,1,15.485,19.677ZM19.846,12.2a1.07,1.07,0,1,1,1.07-1.07A1.083,1.083,0,0,1,19.846,12.2Zm-1.6,3.3a2.759,2.759,0,1,1-2.759-2.759A2.77,2.77,0,0,1,18.244,15.494ZM15.49,0a15.49,15.49,0,1,0,15.49,15.49A15.535,15.535,0,0,0,15.49,0Zm8.185,19.231a4.559,4.559,0,0,1-4.54,4.54H11.748a4.559,4.559,0,0,1-4.54-4.54V11.845a4.559,4.559,0,0,1,4.54-4.54h7.387a4.559,4.559,0,0,1,4.54,4.54Z"
                        transform="translate(0 0)"
                        fill="#0b2a4a"
                      ></path>
                    </svg>
                  </span>
                </a>
              </div>
              <div className="cell auto center">
                <a
                  title="Link to RHI Magnesita page on LinkedIn"
                  href="https://www.linkedin.com/company/rhi-magnesita/"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  <span className="social-icon-new">
                    <svg
                      id="linkedin-icon-svg"
                      xmlns="http://www.w3.org/2000/svg"
                      width="30.979"
                      height="30.979"
                      viewBox="0 0 30.979 30.979"
                    >
                      <path
                        id="linkedin-icon-svg-path"
                        data-name="Pfad 4"
                        d="M21.288,16.976v4.308h-2.44V17.464c0-.91-.015-2.086-1.268-2.086-1.273,0-1.467.992-1.467,2.018v3.887h-2.44V13.428h2.343V14.5h.034a2.566,2.566,0,0,1,2.309-1.268C20.833,13.234,21.288,14.86,21.288,16.976ZM9.7,21.288H12.14V13.428H9.7v7.861ZM10.92,9.526a1.416,1.416,0,1,0,1.418,1.413A1.413,1.413,0,0,0,10.92,9.526ZM30.979,15.49A15.49,15.49,0,1,1,15.49,0,15.535,15.535,0,0,1,30.979,15.49ZM23.723,8.442A1.2,1.2,0,0,0,22.5,7.256H8.471A1.2,1.2,0,0,0,7.256,8.442V22.532a1.2,1.2,0,0,0,1.215,1.186H22.5a1.2,1.2,0,0,0,1.22-1.186Z"
                        transform="translate(0 0)"
                        fill="#0b2a4a"
                      ></path>
                    </svg>
                  </span>
                </a>
              </div>
              <div className="cell auto center">
                <a
                  title="Link to RHI Magnesita page on YouTube"
                  href="https://www.youtube.com/c/rhimagnesita"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  <span className="social-icon-new">
                    <svg
                      id="youtube-icon-svg"
                      xmlns="http://www.w3.org/2000/svg"
                      width="30.979"
                      height="30.979"
                      viewBox="0 0 30.979 30.979"
                    >
                      <path
                        id="youtube-icon-svg-path"
                        data-name="Pfad 6"
                        d="M15.49,0a15.49,15.49,0,1,0,15.49,15.49A15.535,15.535,0,0,0,15.49,0Zm9.086,20.083A2.39,2.39,0,0,1,22.9,21.773a56.622,56.622,0,0,1-7.411.4,56.622,56.622,0,0,1-7.411-.4A2.373,2.373,0,0,1,6.4,20.083a24.937,24.937,0,0,1-.4-4.594A24.937,24.937,0,0,1,6.4,10.9,2.39,2.39,0,0,1,8.079,9.207a56.623,56.623,0,0,1,7.411-.4,56.622,56.622,0,0,1,7.411.4A2.373,2.373,0,0,1,24.575,10.9a24.937,24.937,0,0,1,.4,4.594A24.937,24.937,0,0,1,24.575,20.083ZM13.549,12.672l4.957,2.817-4.957,2.817Z"
                        transform="translate(0 0)"
                        fill="#0b2a4a"
                      ></path>
                    </svg>
                  </span>
                </a>
              </div>
              <div className="cell auto center">
                <a
                  title="Link to RHI Magnesita page on WeChat"
                  href="https://www.rhimagnesita.com/wechat/"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  <span className="social-icon-new">
                    <svg
                      id="wechat-icon-svg"
                      xmlns="http://www.w3.org/2000/svg"
                      width="30.979"
                      height="30.979"
                      viewBox="0 0 30.979 30.979"
                    >
                      <path
                        id="wechat-icon-svg-path"
                        data-name="Pfad 5"
                        d="M14.192,11.578a.944.944,0,1,1,.944.944A.942.942,0,0,1,14.192,11.578Zm-3.78-.944a.944.944,0,1,0,.944.944A.942.942,0,0,0,10.412,10.635Zm7,4.918a.789.789,0,1,0,.789.789A.789.789,0,0,0,17.416,15.552Zm3.935,0a.789.789,0,1,0,.789.789A.789.789,0,0,0,21.351,15.552Zm9.628-.063A15.49,15.49,0,1,1,15.49,0,15.535,15.535,0,0,1,30.979,15.49ZM13.161,19.362a4.513,4.513,0,0,1-.237-1.447c0-2.972,2.89-5.383,6.457-5.383.131,0,.257,0,.382.01-.532-2.817-3.461-4.976-6.995-4.976-3.911,0-7.082,2.643-7.082,5.9a5.561,5.561,0,0,0,2.449,4.463.475.475,0,0,1,.2.387.513.513,0,0,1-.024.15c-.121.445-.31,1.157-.319,1.191a.752.752,0,0,0-.039.174.238.238,0,0,0,.237.237.265.265,0,0,0,.136-.044l1.549-.9a.735.735,0,0,1,.586-.077,8.376,8.376,0,0,0,2.314.324Zm12.125-1.447c0-2.716-2.643-4.918-5.9-4.918s-5.9,2.2-5.9,4.918,2.643,4.918,5.9,4.918a6.965,6.965,0,0,0,1.927-.271.659.659,0,0,1,.174-.024.61.61,0,0,1,.315.092l1.292.745a.237.237,0,0,0,.116.039.2.2,0,0,0,.2-.2.527.527,0,0,0-.034-.145c-.01-.029-.165-.62-.266-.992a.566.566,0,0,1-.019-.126.4.4,0,0,1,.165-.319A4.636,4.636,0,0,0,25.287,17.915Z"
                        transform="translate(0 0)"
                        fill="#0b2a4a"
                      ></path>
                    </svg>
                  </span>
                </a>
              </div>
              <div className="cell auto center">
                <a
                  title="Link to RHI Magnesita page on Flickr"
                  href="https://www.flickr.com/photos/184898908@N05/albums"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  <span className="social-icon-new">
                    <svg
                      id="flickr-icon-svg"
                      xmlns="http://www.w3.org/2000/svg"
                      width="30.979"
                      height="30.979"
                      viewBox="0 0 30.979 30.979"
                    >
                      <path
                        id="flickr-icon-svg-path"
                        data-name="Pfad 2"
                        d="M15.49,0a15.49,15.49,0,1,0,15.49,15.49A15.535,15.535,0,0,0,15.49,0ZM7.222,14.037v1.254H5.993v3.926H4.269V15.291H3.253V14.037H4.3v-.319c0-1.539.7-2.077,2.081-2.077a4.239,4.239,0,0,1,.881.1l-.106,1.234a1.563,1.563,0,0,0-.547-.077c-.44,0-.615.319-.615.823v.315Zm2.561,5.179H8.055V11.762H9.783Zm2.628,0H10.683V14.037h1.728Zm0-6.022H10.683V11.883h1.728Zm3.577,6.143a2.713,2.713,0,1,1,0-5.412,2.942,2.942,0,0,1,1.37.29l-.126,1.312a1.847,1.847,0,0,0-1.046-.29,1.311,1.311,0,0,0-1.326,1.433,1.368,1.368,0,0,0,1.418,1.36,2.286,2.286,0,0,0,1.075-.247l.039,1.331A4.7,4.7,0,0,1,15.988,19.338Zm5.349-.121-1.38-2.565h-.019v2.565H18.21V11.762h1.728v4.453h.019l1.438-2.178h1.888l-1.738,2.377,1.883,2.8Zm5.721-3.8c-.8,0-1.259.605-1.259,1.622v2.188H24.072V14.037h1.573v.954h.019a1.544,1.544,0,0,1,1.476-1.075,3.637,3.637,0,0,1,.586.058l-.087,1.491A2.114,2.114,0,0,0,27.058,15.412Z"
                        transform="translate(0 0)"
                        fill="#0b2a4a"
                      ></path>
                    </svg>
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
